import dayjs from 'dayjs'
import ar from 'dayjs/locale/ar-sa'
import az from 'dayjs/locale/az'
import de from 'dayjs/locale/de'
import en from 'dayjs/locale/en'
import es from 'dayjs/locale/es'
import ru from 'dayjs/locale/ru'
import tr, { Locale } from 'dayjs/locale/tr'
import it from 'dayjs/locale/it'
import fr from 'dayjs/locale/fr'
import pt from 'dayjs/locale/pt'
import ro from 'dayjs/locale/ro'
import pl from 'dayjs/locale/pl'
import lt from 'dayjs/locale/lt'
import uz from 'dayjs/locale/uz-latn'
import sr from 'dayjs/locale/sr'
import ky from 'dayjs/locale/ky'
import tg from 'dayjs/locale/tg'
import kk from 'dayjs/locale/kk'
import nl from 'dayjs/locale/nl'
import zh from 'dayjs/locale/zh'
import ka from 'dayjs/locale/ka'
import hi from 'dayjs/locale/hi'
import ja from 'dayjs/locale/ja'
import ko from 'dayjs/locale/ko'
import ur from 'dayjs/locale/ur'
import ta from 'dayjs/locale/ta'
import th from 'dayjs/locale/th'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(duration)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)

// Azerbaycan dilindeki ay isimlerinin ilk harflerini büyük harf yap
if (az?.months) {
  const toUpperCase = (str: string) => str.replace(/^i/i, 'İ').replace(/^./i, (c) => c.toLocaleUpperCase())
  az.months = az.months.map(toUpperCase)
  az.monthsShort = az.monthsShort?.map(toUpperCase)
}

const locales = { tr, ar, en, es, de, ru, az, it, fr, pt, ro, pl, lt, uz, sr, ky, tg, kk, nl, zh, ka, hi, ja, ko, ur, ta, th }

const marketsWeekStarts = {
  eg: 0,
  sa: 0,
  kw: 0,
  om: 0,
  bh: 0,
  jo: 0,
  qa: 0,
  pk: 1,
  in: 1,
  ae: 1,
  de: de.weekStart,
  us: 1,
  gb: 1,
  tr: tr.weekStart,
  es: es.weekStart,
  ru: ru.weekStart,
  kz: ru.weekStart,
  uz: ru.weekStart,
  tj: ru.weekStart,
  kg: ru.weekStart,
  lb: 1,
  ca: 1,
  au: 1,
  nz: 1,
  za: 1,
  at: de.weekStart,
  ch: de.weekStart,
  iq: 1,
  ma: 1,
  ge: 1,
  mx: 1,
  az: 1,
  // Yeni eklenen diller
  it: it.weekStart ?? 1,
  fr: fr.weekStart ?? 1,
  pt: pt.weekStart ?? 1,
  ro: ro.weekStart ?? 1,
  pl: pl.weekStart ?? 1,
  lt: lt.weekStart ?? 1,
  sr: sr.weekStart ?? 1,
  ky: ky.weekStart ?? 1,
  tg: tg.weekStart ?? 1,
  kk: kk.weekStart ?? 1,
  nl: nl.weekStart ?? 1,
  // Wingie 8 yeni dil
  zh: zh.weekStart ?? 1,
  ka: ka.weekStart ?? 1,
  hi: hi.weekStart ?? 0,
  ja: ja.weekStart ?? 0,
  ko: ko.weekStart ?? 0,
  ur: ur.weekStart ?? 1,
  ta: ta.weekStart ?? 0,
  th: th.weekStart ?? 0,
}

export const DayJsLanguage = (locale, market) => {
  const $locale = locales[locale === 'default' ? 'tr' : locale] as Locale

  // Eğer locale bulunamazsa fallback olarak İngilizce kullan
  if (!$locale) {
    console.warn(`DayJS locale not found for '${locale}', falling back to English`)
    dayjs.locale(locales['en'])
    return
  }

  if (marketsWeekStarts[market] === undefined) {
    if (market === locale) return
    market = locale
  }
  $locale.weekStart = marketsWeekStarts[market] ?? 0

  dayjs.locale($locale)
}

/**
 * Parse the given date string using by the locale (tr) or full locale (tr-tr) value.
 *
 * @param string dateString
 * @param string locale - default: tr
 * @returns Date string
 */
export const localeDateStringParser = (dateString: string, locale = 'tr') => {
  const _locale = locale.split('-')?.[1] || locale

  return new Date(dateString).toLocaleDateString(_locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
